import React from 'react';
import './Dashboard.css';
import dashboardImage from '../../assets/dashboard.png';

const Dashboard = () => {
  return (
    <section className="dashboard-section">
      <div className="dashboard-container">
        <h2 className="dashboard-main-title">
          VOTRE DASHBOARD UNIFIÉ
        </h2>
        
        <div className="dashboard-content">
          <div className="dashboard-image-container">
            <img 
              src={dashboardImage}
              alt="Dashboard Prosperian" 
              className="dashboard-image"
            />
          </div>
          
          <div className="dashboard-info">
            <h3 className="dashboard-subtitle">
              TOUTE VOTRE PROSPECTION EN UN COUP D'ŒIL
            </h3>
            <p className="dashboard-description">
              Aperçu de notre interface intuitive, tableau de bord personnalisable et suivi en temps réel 
              de vos campagnes multi-canaux.
            </p>
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="dashboard-button">DEMANDER UNE DÉMO</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard; 